const items = [
  {
    title: "2023 - presente",
    cardTitle: "Tecnólogo Análise e Desenvolvimento de Sistemas",
    cardSubtitle:
      "Curso de Análise e Desenvolvimento de Sistemas na Faculdade Técnica FATEC - Mogi Mirim",
  },
  {
    title: "2020 - 2022",
    cardTitle: "Desenvolvimento de Sistemas",
    cardSubtitle:
      "Curso de Desenvolvimento de Sistemas integrado ao Ensino Médio feito na ETEC Pedro Fereira Alves - Mogi Mirim",
  },
  {
    title: "2019 - 2021",
    cardTitle: "Hardware e Redes",
    cardSubtitle:
      "Curso de Hardware e Redes feito na InfoFixPlus - Mogi Guaçu ",
    cardDetailedText: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel facilis placeat porro eligendi, labore quos illum nesciunt laborum accusamus praesentium amet laudantium nemo provident eos ipsam ut nobis dicta optio obcaecati aliquam. Dicta explicabo dolorem illo hic, quod eum! Cum, corrupti pariatur veritatis, maxime repellendus nulla blanditiis dolores delectus aut exercitationem cupiditate voluptates itaque perspiciatis odio, id harum recusandae hic aperiam porro qui beatae? Facilis reprehenderit dolorum hic est, earum quis a ea recusandae aperiam asperiores, temporibus dolores, quisquam dicta doloribus eum voluptatum nostrum. Praesentium, ipsum veniam ad nobis similique eaque asperiores voluptates ipsam culpa quia officia accusamus dolorum cum deleniti.",
  },
];

export default items;
